import _ from 'lodash'
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader, Grid, Header, Image, Message } from 'semantic-ui-react'
import queryString from 'query-string'
import { useForm, FormProvider } from 'react-hook-form'
import { useParams, Redirect } from 'react-router-dom'
import { logout, login } from '../../actions/identity'
import { getClient } from '../../actions/clients'
import identitySelectors from '../../selectors/identity'
import clientsSelectors from '../../selectors/clients'
import LoginHeader from '../../components/LoginHeader'
import LoginForm from '../../components/LoginForm'
import './Login.scss';

export default function Login() {
  const query = queryString.parse(window.location.search);
  const loginForm = useForm({
    defaultValues: {
      email: query.email || '',
      password: '',
      remember: true
    }
  });
  const dispatch = useDispatch();
  const params = useParams<{site: string, invalid?: string}>();
  const year = new Date().getFullYear();
  const remember = loginForm.watch('remember')
  const submit = ({ email, password }: any) => {
    dispatch(login({email, password}));
  };

  const isLoggedIn         = useSelector(identitySelectors.isLoggedIn);
  const postForgotPassword = useSelector(identitySelectors.postForgotPassword);
  const postLogin          = useSelector(identitySelectors.postLogin);
  const getClientSelector  = useSelector(clientsSelectors.getClient);

  const sentForgotPassword = !postForgotPassword.loading && postForgotPassword.payload
  const loginFailure       = !sentForgotPassword && postLogin.error
  const authenticationType = _.get(getClientSelector, 'payload.data.attributes.authentication-type');
  const isLDAP             = authenticationType === 'ldap';

  const renderSentForgotPassword = () => (
    <Message className="feedback" positive>
      Please check your email for login instructions
    </Message>
  )
  const renderLoginFailure = () => (
    <Message className="feedback" negative>
      { _.get(postLogin, 'error.response.message', "We were unable to log you in") }
    </Message>
  )
  useEffect(() => {
    if(!getClientSelector.payload) dispatch(getClient(params.site))
  }, [dispatch, getClientSelector.payload, params.site]);
  useEffect(() => {
    if(query.invalid) {
      console.log("Logging out");
      dispatch(logout(params.site));
    }
  }, [dispatch, params.site, query.invalid]);

  if(isLoggedIn && !query.invalid) {
    return (
      <Redirect to={{
        pathname: `/${params.site}/landing`,
          search: queryString.stringify({
            remember,
            redirect: query.redirect as string
          }),
        }}
      />
    );
  }

  if(!authenticationType) {
    return (<Loader active inline='centered'/>);
  }
 
  return (
    <Grid className="Login" verticalAlign='middle' centered>
      <Grid.Column style={{ maxWidth: 450 }}>
        <Grid.Row>
          <Header textAlign='center'>
            <Image src='/assets/gogov-logo.svg' style={{ width: '200px' }} />
          </Header>
        </Grid.Row>
        <Grid.Row textAlign='left'>
          { sentForgotPassword ? renderSentForgotPassword() : null }
          { loginFailure ? renderLoginFailure() : null }
          <FormProvider {...loginForm}>
            <LoginHeader site={params.site}/>
            <LoginForm
              onSubmit={submit}
              site={params.site}
              username={{
                label: isLDAP ? 'Username' : 'Email',
                  placeholder: isLDAP ? 'Username' : 'Email'
              }}
              allowRememberMe={!isLDAP}
            />
          </FormProvider>
        </Grid.Row>
        <Grid.Row centered>
          <div>© {year} GOGov, Inc. All rights reserved.</div>
        </Grid.Row>
      </Grid.Column>
    </Grid>
  );
}
